import { log, LogTag } from "services/logger";

export const onCastStateChanged = (data: cast.framework.CastStateEventData) => {
    log.debug([LogTag.Chromecast], () => ({ code: "web-211015-0958", msg: `onCastStateChanged: ${data.castState}` }));
};
